import { render, staticRenderFns } from "./TaxRiskAnalysis.vue?vue&type=template&id=21307a3a&scoped=true"
import script from "./TaxRiskAnalysis.vue?vue&type=script&lang=js"
export * from "./TaxRiskAnalysis.vue?vue&type=script&lang=js"
import style0 from "./TaxRiskAnalysis.vue?vue&type=style&index=0&id=21307a3a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21307a3a",
  null
  
)

export default component.exports